export default {
  computed:{
    getLogInStatus(){
      return localStorage.getItem('userData') || null
    }
  }
}
